import { Affix, Button, Card } from "antd";
import { LINE_WISE_OPERATIONS_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getData } from "../../../apiServices/common";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import HourlyOperationTracking from "./HourlyOperationTrackingForm";

export default function ViewHourlyOperationTracking(props) {
  // Props
  const { width } = props;

  // Router
  let { id } = useParams();
  const navigate = useNavigate();

  // States
  const [info, setInfo] = useState();

  // Others
  const propertyFormRef = useRef(null);
  const edit_url = `${LINE_WISE_OPERATIONS_ENDPOINT}/${id}`;

  const discartForm = () => {
    navigate("/digitalization/hourly-operation-tracking");
  };

  const getPOInfo = useCallback(async () => {
    let res = await getData(edit_url);

    if (res && res?.data?.code === 200) {
      let masterData = res.data.data;
      setInfo(masterData);
    }
  }, [edit_url]);

  useEffect(() => {
    getPOInfo();
  }, [getPOInfo]);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="View Hourly Operation Tracking"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Back
              </Button>,
            ]}
          ></Header>
        </Card>
      </Affix>

      <HourlyOperationTracking ref={propertyFormRef} info={info} view={true} mode={"view"} />
    </>
  );
}
